import Numeral from 'numeral';

export const mapValueToUSDFormat = (value: string): string =>
  Numeral(value)
    .format('$0,0.0a')
    .replace(/[a-z]/g, match => match.toUpperCase())
    .replace('.0', '');
